import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
  GET_CHECKLIST: "api/Checklist",
  ADD_CHECKLIST: "api/Checklist",
  DELETE_CHECKLIST: "api/Checklist",
  GET_SEPARATIONMODES: "api/SeparationModes",
  ADD_EMPLOYEE_SEPARATION: "api/EmployeeSeparation",
  GET_ALL_SEPARATION_RECODS: "api/AllSeparationRecords",
  GET_EMPLOYEE_SEPARATION_DETAILS: "api/EmployeeSeparationDetails",
  DELETE_EMPLOYEE_SEPARATION: "api/EmployeeSeparation",
  SEPARATION_EXPORT: "api/SeparationRecords/Export",
};

const getCheckList = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.GET_CHECKLIST}?from=${data.from}&to=${data.to}&search=${data.search}`,
  );
  return res.data;
};

const addCheckList = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.ADD_CHECKLIST,
    data,
  );
  return res.data;
};

const deleteCheckList = async (id: number): Promise<ApiResponse<any>> => {
  const res = await privateRequest.delete<ApiResponse<any>>(
    `${ENDPOINTS.DELETE_CHECKLIST}/${id}`,
  );
  return res.data;
};

const getSeparationModes = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.GET_SEPARATIONMODES}?from=${data.from}&to=${data.to}&search=${data.search}`,
  );
  return res.data;
};

const addEmployeeSeparation = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.ADD_EMPLOYEE_SEPARATION,
    data,
  );
  return res.data;
};

const getAllSeparationRecords = async (
  data: any,
): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.GET_ALL_SEPARATION_RECODS,
    data,
  );
  return res.data;
};

const getEmployeeSeparationDetails = async (
  data: any,
): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.GET_EMPLOYEE_SEPARATION_DETAILS}?separationUserId=${data}`,
  );
  return res.data;
};

const deleteEmployeeSeparation = async (
  id: number,
): Promise<ApiResponse<any>> => {
  const res = await privateRequest.delete<ApiResponse<any>>(
    `${ENDPOINTS.DELETE_EMPLOYEE_SEPARATION}/${id}`,
  );
  return res.data;
};

export const separationExport = async (payload: any) => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.SEPARATION_EXPORT,
    payload,
    { responseType: "arraybuffer" },
  );
  return res;
};

const UserSeparation = {
  getCheckList,
  addCheckList,
  deleteCheckList,
  getSeparationModes,
  addEmployeeSeparation,
  getAllSeparationRecords,
  getEmployeeSeparationDetails,
  deleteEmployeeSeparation,
  separationExport,
};

export default UserSeparation;
